module.exports = __webpack_public_path__ + "1244ab02607fae0b521bb01387849ab1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bb-cream/med-swatch.jpg
 ** module id = 425
 ** module chunks = 0
 **/